import PageContentHeader from './PageContentHeader';

export default PageContentHeader;
